import React from "react";
import { useSearchParams } from "react-router-dom";

export const ConceptRail = ({sentences, jumpToAudio}) => {
    const sentenceWithConcepts =
         sentences
            .filter(s => s.conceptList && s.conceptList.length > 0)
            .reduce(
                ([acc, seenSet], next) => 
                    [[...acc, 
                        { ...next, 
                            conceptList: next.conceptList.filter(
                                    cnext => {
                                        const retVal = !seenSet.has(cnext.name)
                                        seenSet.add(cnext.name);
                                        return retVal;
                                    })
                        }
                    ], 
                   seenSet],
                [[],new Set()]
            )[0]
            .filter(s =>  s.conceptList.length > 0);

            
    if(sentenceWithConcepts.length === 0)
        return "";

    return <div className="w-full flex flex-col">
        {
           sentenceWithConcepts[0].start > 5 ? 
                <div className="h-[20px]  bg-blue-300 w-[5px] self-center"></div> :
                ""
        }
        {
           sentenceWithConcepts
            .map(s => ({...s, 
                time: { 
                    min: (Math.round(s.start) - Math.round(s.start) % 60) / 60, 
                    sec: Math.round(s.start) % 60 }}))
            .map((s, idx) => 
           <React.Fragment key={"concept_rail_"+idx} >
            <div className="self-center">
                <div className="w-full font-bold my-1">
                    {(s.time.min > 0 ? s.time.min + " min" : "")} {(s.time.sec > 0 ? s.time.sec + " sec" : "")}
                </div>
            </div>
            <div className="self-center text-center flex flex-col" onClick={() => jumpToAudio(s.start)}>
                {s.conceptList.map((c, i_idx) => 
                        (<button key={i_idx} title={c.name} className="text-underline md:w-48 w-32 underline my-1 rounded-md whitespace-nowrap self-start truncate">{c.name}</button>)
                    )}
            </div>
            <div className="h-[20px]  bg-blue-300 w-[5px] self-center"></div>
            </React.Fragment>
            )
        }
    </div>;
}